<template>
  <div>
    <v-data-table
      :headers="acceptanceWorkItemDataTableHeaders"
      :items="editedEngineerWork.EngineerWorkItems"
      class="elevation-1 my-5 mx-5"
      :search="searchWorkItems"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('engineer_item_repair_item_return_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchWorkItems"
            append-icon="mdi-magnify"
            :label="$t('quotation_item_new_install_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="openEditedDialog"
            :disabled="
              isAllTextFieldDisable ||
                !editedEngineerWork.IsAccept ||
                editedEngineerWork.IsDone ||
                editedEngineerWork.IsOutOfTime
            "
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowEditWorkItemDialog" persistent fullscreen>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ title }}</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <!--驗收-裝-->
              <ValidationObserver ref="workItem">
                <v-card flat>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-checkbox
                            v-model="editedWorkItem.ReturnItem.IsCustomerDevice"
                            :label="$t('quotation_item_is_customer_device')"
                            required
                            :disabled="editedWorkItem.IsDone"
                            @change="setIsCustomerDevice"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.ReturnItem.CustomerDeviceType"
                            :items="computedCustomerDeviceTypeList"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('engineer_item_customer_device_type')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-if="editedWorkItem.ReturnItem.IsCustomerDevice"
                            :disabled="editedWorkItem.IsDone"
                            @keyup.enter="setAcceptanceCustomerDeviceTypeAutocomplete"
                            ref="acceptanceDeviceTypeAutocomplete"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <item-autocomplete-for-eg
                            :fatherEditedItem="editedWorkItem.ReturnItem"
                            :licensePlate="editedEngineerWork.LicensePlate"
                            :editedItemIndex="-1"
                            :itemName="'quotation_item_number'"
                            :customerDeviceType="editedWorkItem.ReturnItem.CustomerDeviceType"
                            @setEditedItem="setEditedReturnItem"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            v-if="editedWorkItemIndex === -1"
                            refName="acceptanceItemAutocomplete"
                            @keyupEnter="focusNextInput"
                          />
                          <ValidationProvider
                            :name="$t('quotation_item_name')"
                            rules="required"
                            v-slot="{ errors }"
                            v-else
                          >
                            <v-text-field
                              v-model="editedWorkItem.ReturnItem.Name"
                              :label="$t('quotation_item_name')"
                              disabled
                              :error-messages="errors[0]"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('quotation_item_name') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_real_quantity')"
                            :rules="{ required: true, is: isCheckReturnItemQuantity }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedWorkItem.ReturnItem.RealQuantity"
                              required
                              clearable
                              :disabled="editedWorkItem.IsDone"
                              :error-messages="errors[0]"
                              @keyup.enter="focusNextInput"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_real_quantity') }}
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row
                        v-if="
                          editedWorkItem.ReturnItem.HasSerialNumber &&
                            editedWorkItem.ReturnItem.RealQuantity > 0 &&
                            (!editedWorkItem.RemoveItem.IsCustomerDevice ||
                              (editedWorkItem.RemoveItem.IsCustomerDevice &&
                                editedWorkItem.RemoveItem.CustomerDeviceType === 3))
                        "
                      >
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-combobox
                            v-model="editedWorkItem.ReturnItem.SerialNumber"
                            :label="$t('quotation_item_serialnumber')"
                            v-if="
                              editedWorkItemIndex === -1 ||
                                (!editedWorkItem.IsDone &&
                                  editedWorkItem.ReturnItem.Number !== '' &&
                                  editedWorkItem.ReturnItem.HasSerialNumber)
                            "
                            :items="returnItemSerialNumberList"
                            item-text="Number"
                            item-value="Number"
                            required
                            return-object
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            @change="setReturnSerialNumber"
                            :search-input.sync="searchInput"
                            @keyup.enter="setAcceptanceSerialNumberAutocomplete"
                            ref="acceptanceSerialNumberAutocomplete"
                          >
                            <template v-slot:append-item>
                              <div v-intersect="isScrollBarBottom" />
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.Number }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.ItemName }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-combobox>
                          <v-text-field
                            v-model="editedWorkItem.ReturnItem.SerialNumber.Number"
                            :label="$t('quotation_item_serialnumber')"
                            disabled
                            v-else-if="editedWorkItem.ReturnItem.SerialNumber"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.ReturnItem.InstallPosition"
                            :items="allInstallPositionType"
                            item-text="Name"
                            item-value="Type"
                            :label="$t('quotation_item_install_position')"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            :disabled="editedWorkItem.IsDone || editedWorkItemIndex !== -1"
                            @keyup.enter="setAcceptanceInstallPositionAutocomplete"
                            @change="setChangeReturnItemInstallPosition"
                            ref="acceptanceInstallPositionAutocomplete"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            v-model="editedWorkItem.ReturnItem.Custody"
                            :items="allCustodyType"
                            item-text="Name"
                            item-value="Type"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            @keyup.enter="setCustodyAutocomplete"
                            ref="custodyTypeAutocomplete"
                            :disabled="
                              editedWorkItem.IsDone || !editedWorkItem.ReturnItem.IsCustomerDevice
                            "
                            :label="$t('resume_item_custody')"
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row v-if="editedWorkItem.ReturnItem.HasAuthorize">
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-autocomplete
                            :items="gmTypeList"
                            item-text="Name"
                            item-value="Type"
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            v-model="editedWorkItem.ReturnItem.GmServerType"
                            label="GM"
                            :disabled="editedWorkItem.IsDone"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-text-field
                            v-model="editedWorkItem.ReturnItem.AuthorizeItemSerialNumber"
                            label="授權序號"
                            disabled
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                          <v-select
                            v-model="defaultText"
                            :disabled="isAllTextFieldDisable"
                            :items="defaultTextList"
                            @change="changeDefaultText"
                            label="預設文字"
                            v-if="
                              editedWorkItem.ReturnItem.Quantity * 1 !==
                                editedWorkItem.ReturnItem.RealQuantity * 1
                            "
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <ValidationProvider
                            :name="$t('installation_acceptance_item_reason')"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              editedWorkItem.ReturnItem.Quantity * 1 !==
                                editedWorkItem.ReturnItem.RealQuantity * 1
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                {{ $t('installation_acceptance_item_reason') }}
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                          <ValidationProvider
                            name="換GM Server原因"
                            rules="required"
                            v-slot="{ errors }"
                            v-if="
                              editedWorkItem.ReturnItem.HasAuthorize &&
                                tempGmServerType !== editedWorkItem.ReturnItem.GmServerType
                            "
                          >
                            <v-textarea
                              outlined
                              v-model="editedWorkItem.Reason"
                              :error-messages="errors[0]"
                              :disabled="editedWorkItem.IsDone"
                            >
                              <template v-slot:label>
                                <span class="red--text">
                                  <strong>* </strong>
                                </span>
                                換GM Server原因
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </ValidationObserver>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="closeEditWorkItem">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="addWorkItem"
                  :disabled="editedWorkItem.IsDone"
                >
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="false"
            :isLoadingSaveBtn="false"
            :isShowDeleteDialog="isShowDeleteEngineerWorkDialog"
            :deleteMessage="'installation_acceptance_item_delete_dialog_message'"
            @closeDelete="closeDeleteWorkItem"
            @confirmDelete="confirmDeleteWorkItem"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          icon
          small
          class="mr-2"
          @click="isShowEditWorkItemDialogBtn(item)"
          :disabled="
            isAllTextFieldDisable ||
              !editedEngineerWork.IsAccept ||
              editedEngineerWork.IsDone ||
              editedEngineerWork.IsOutOfTime
          "
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          icon
          small
          @click="isShowDeleteWorkItemDialogBtn(item)"
          :disabled="
            isAllTextFieldDisable ||
              !editedEngineerWork.IsAccept ||
              editedEngineerWork.IsDone ||
              editedEngineerWork.IsOutOfTime
          "
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.ReturnItem.InstallPosition`]="{ item }">
        {{ turnData(item.ReturnItem.InstallPosition) }}
      </template>
      <template v-slot:[`item.ReturnItem.Custody`]="{ item }">
        {{ turnCustodyData(item.ReturnItem.Custody) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import {
  HttpSerialNumber,
  HttpFix,
  HttpAuthorizeMapping,
  HttpInstallPosition
} from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
import ItemAutocompleteForEg from '@/components/ItemAutocompleteForEg.vue'
import { extend } from 'vee-validate'
import { is } from 'vee-validate/dist/rules'
import { CustodyType } from '@/js/CustodyType'

export default {
  components: { DeleteDialog, ItemAutocompleteForEg },
  name: 'EngineerWorkNotDoneAcceptance',
  props: {
    headerProps: {
      type: Object
    },
    editedEngineerWork: {
      type: Object
    },
    isAllTextFieldDisable: {
      type: Boolean
    },
    allInstallPositionType: {
      type: Array
    },
    inCarItemList: {
      type: Array
    },
    customerDeviceTypeList: {
      type: Array
    }
  },
  data: () => ({
    searchWorkItems: '',
    isShowDeleteEngineerWorkDialog: false,
    isShowEditWorkItemDialog: false,
    editedWorkItem: {
      RemoveItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        Type: '',
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        GmServerType: 0,
        AuthorizeItemSerialNumber: ''
      },
      ReturnItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Type: '',
        Quantity: 0,
        RealQuantity: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        GmServerType: 0,
        AuthorizeItemSerialNumber: ''
      },
      Reason: ''
    },
    defaultWorkItem: {
      RemoveItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        Type: '',
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        GmServerType: 0,
        AuthorizeItemSerialNumber: ''
      },
      ReturnItem: {
        BomName: '',
        BuyOrRentType: 0,
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        Type: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        IsCustomerDevice: false,
        CustomerDeviceType: 0,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        GmServerType: 0,
        AuthorizeItemSerialNumber: ''
      },
      Reason: ''
    },
    editedWorkItemIndex: -1,
    returnItemSerialNumberList: [],
    searchInput: null,
    inCarItem: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      Quantity: 0,
      InstallPosition: 0,
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      IsOutOfWarranty: false
    },
    tempChangeItem: null,
    tempOriginalItem: null,
    page: 1,
    perPage: 10,
    tempWatchNumber: '',
    searchCount: 0,
    isGetItemFinish: false,
    getIntersectingObj: null,
    allCustodyType: [],
    gmTypeList: [],
    tempGmServerType: 0,
    authorizeMappingObj: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      ItemSerialNumber: '',
      AuthorizeItemSerialNumber: '',
      GmServerType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      DoneTime: 0
    },
    installPositionList: [],
    defaultText: ''
  }),
  async mounted () {
    extend('is', {
      ...is,
      message: () => '只能填寫0、1'
    })
    await this.getAllCustodyType()
    await this.getGmTypeList()
    await this.getInstallPositionList()
  },
  computed: {
    defaultTextList () {
      return ['無初始化履歷卡', '初始化履歷卡錯誤']
    },
    acceptanceWorkItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'ReturnItem.BomName'
        },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'ReturnItem.Name' },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'ReturnItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'ReturnItem.InstallPosition'
        },
        {
          text: this.$t('resume_item_custody'),
          align: 'start',
          value: 'ReturnItem.Custody'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    title () {
      return this.editedWorkItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    isCheckReturnItemQuantity () {
      return (
        (this.editedWorkItem.ReturnItem.HasSerialNumber ||
          (this.editedWorkItem.ReturnItem.InstallPosition !== 0 &&
            this.editedWorkItem.ReturnItem.InstallPosition !== null)) &&
        this.editedWorkItem.ReturnItem.RealQuantity * 1 !== 0 &&
        this.editedWorkItem.ReturnItem.RealQuantity * 1 !== 1
      )
    },
    computedCustomerDeviceTypeList () {
      let array = []
      if (this.editedWorkItem.ReturnItem.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedWorkItem.ReturnItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    }
  },
  watch: {
    async searchInput (val) {
      this.tempWatchNumber = val
      this.page = 1
      this.returnItemSerialNumberList = []
      this.isGetItemFinish = true
      await this.getTotalCount()
      await this.getReturnItemSerialNumber()
      this.isGetItemFinish = false
    },
    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isGetItemFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getReturnItemSerialNumber()
        }
      }
    }
  },
  methods: {
    changeDefaultText () {
      this.editedWorkItem.Reason = this.defaultText
      this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
    },
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installPositionList = response.status === 200 ? response.data.Data : []
    },
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    async getAuthorizeMappingByItemIdAndItemSerialNumber () {
      if (this.editedWorkItem.ReturnItem.SerialNumber) {
        let response = await HttpAuthorizeMapping.GetAuthorizeMappingByItemIdAndItemSerialNumber({
          itemId: this.editedWorkItem.ReturnItem.ItemId,
          itemSerialNumber: this.editedWorkItem.ReturnItem.SerialNumber.Number
        })
        this.authorizeMappingObj = response && response.status === 200 ? response.data.Data : {}
      }
    },
    turnCustodyData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    setCustodyAutocomplete (event) {
      this.$refs.custodyTypeAutocomplete.isMenuActive = false
      this.$refs.custodyTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    async setIsCustomerDevice () {
      if (this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.CustomerDeviceType = 3
      } else {
        this.editedWorkItem.ReturnItem.CustomerDeviceType = 0
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      this.editedWorkItem.ReturnItem.SerialNumber = JSON.parse(
        JSON.stringify(this.defaultWorkItem.ReturnItem.SerialNumber)
      )
      this.page = 1
      this.returnItemSerialNumberList = []
      this.isGetItemFinish = true
      await this.getTotalCount()
      await this.getReturnItemSerialNumber()
      this.isGetItemFinish = false
    },
    turnData (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(
        value,
        this.installPositionList
      )
    },
    openEditedDialog () {
      if (!this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      this.isShowEditWorkItemDialog = true
    },
    setAcceptanceInstallPositionAutocomplete (event) {
      this.$refs.acceptanceInstallPositionAutocomplete.isMenuActive = false
      this.$refs.acceptanceInstallPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setAcceptanceCustomerDeviceTypeAutocomplete (event) {
      this.$refs.acceptanceDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.acceptanceDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setAcceptanceSerialNumberAutocomplete (event) {
      this.$refs.acceptanceSerialNumberAutocomplete.isMenuActive = false
      this.$refs.acceptanceSerialNumberAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    },
    async setReturnSerialNumber () {
      if (typeof this.editedWorkItem.ReturnItem.SerialNumber === 'string') {
        let serialNumberObj = this.returnItemSerialNumberList.find(
          (x) => x.Number === this.editedWorkItem.ReturnItem.SerialNumber
        )
        if (serialNumberObj) {
          this.editedWorkItem.ReturnItem.SerialNumber = JSON.parse(JSON.stringify(serialNumberObj))
        } else {
          this.editedWorkItem.ReturnItem.SerialNumber = JSON.parse(
            JSON.stringify({
              ItemId: this.editedWorkItem.ReturnItem.ItemId,
              ItemNumber: this.editedWorkItem.ReturnItem.Number,
              ItemName: this.editedWorkItem.ReturnItem.Name,
              Number: this.editedWorkItem.ReturnItem.SerialNumber,
              IsUsed: false,
              AcceptanceNumber: '',
              RepairNumber: ''
            })
          )
        }
      }
      if (
        this.editedWorkItem.ReturnItem.SerialNumber &&
        this.editedWorkItem.ReturnItem.SerialNumber.ItemId !== this.editedWorkItem.ReturnItem.ItemId
      ) {
        alert('機器序號搭配的品名與現在品名不一致，已換上機器序號的品名')
        this.editedWorkItem.ReturnItem.ItemId = this.editedWorkItem.ReturnItem.SerialNumber.ItemId
        this.editedWorkItem.ReturnItem.Number = this.editedWorkItem.ReturnItem.SerialNumber.ItemNumber
        this.editedWorkItem.ReturnItem.Name = this.editedWorkItem.ReturnItem.SerialNumber.ItemName
        this.editedWorkItem.ReturnItem.HasSerialNumber = true
        this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
      }
      await this.getAuthorizeMappingByItemIdAndItemSerialNumber()
      if (this.authorizeMappingObj) {
        this.tempGmServerType = this.authorizeMappingObj.GmServerType
        this.editedWorkItem.ReturnItem.GmServerType = this.authorizeMappingObj.GmServerType
        this.editedWorkItem.ReturnItem.AuthorizeItemSerialNumber = this.authorizeMappingObj.AuthorizeItemSerialNumber
        this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
      }
    },
    async setEditedReturnItem (val) {
      this.setChangeReturnItem(val)
      this.setAcceptanceChangeReturnItemQuantity(val)
      this.page = 1
      this.returnItemSerialNumberList = []
      this.isGetItemFinish = true
      await this.getTotalCount()
      await this.getReturnItemSerialNumber()
      this.isGetItemFinish = false
    },
    setChangeReturnItem (val) {
      this.editedWorkItem.ReturnItem.ItemId = val.Id
      this.editedWorkItem.ReturnItem.Number = val.Number
      this.editedWorkItem.ReturnItem.Name = val.Name
      this.editedWorkItem.ReturnItem.Unit = val.Unit
      this.editedWorkItem.ReturnItem.Price = val.Price
      this.editedWorkItem.ReturnItem.IsDelete = val.IsDelete
      this.editedWorkItem.ReturnItem.StoreNo = val.StoreNo
      this.editedWorkItem.ReturnItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedWorkItem.ReturnItem.HasSerialNumber = val.HasSerialNumber
      this.editedWorkItem.ReturnItem.HasAuthorize = val.HasAuthorize
      this.editedWorkItem.ReturnItem.IsExistResume = val.IsExistResume
      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
    },
    setChangeReturnItemInstallPosition () {
      if (
        this.editedWorkItem.ReturnItem.InstallPosition !== null &&
        this.editedWorkItem.ReturnItem.InstallPosition !== 0
      ) {
        this.editedWorkItem.ReturnItem.RealQuantity = 1
      }
    },
    setAcceptanceChangeReturnItemQuantity (val) {
      this.inCarItem = this.inCarItemList.find((x) => x.ItemId === val.Id)

      if (this.editedWorkItem.ReturnItem.HasSerialNumber) {
        if (this.inCarItem) {
          this.editedWorkItem.ReturnItem.Quantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.RealQuantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.inCarItem.InstallPosition
          this.editedWorkItem.ReturnItem.IsCustomerDevice = this.inCarItem.IsCustomerDevice
          this.editedWorkItem.ReturnItem.CustomerDeviceType = this.inCarItem.CustomerDeviceType
        } else {
          this.editedWorkItem.ReturnItem.Quantity = 0
          this.editedWorkItem.ReturnItem.RealQuantity = 1
        }
      } else {
        if (this.inCarItem) {
          this.editedWorkItem.ReturnItem.Quantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.RealQuantity = this.inCarItem.Quantity
          this.editedWorkItem.ReturnItem.InstallPosition = this.inCarItem.InstallPosition
          this.editedWorkItem.ReturnItem.IsCustomerDevice = this.inCarItem.IsCustomerDevice
          this.editedWorkItem.ReturnItem.CustomerDeviceType = this.inCarItem.CustomerDeviceType
        } else {
          this.editedWorkItem.ReturnItem.Quantity = 0
          this.editedWorkItem.ReturnItem.RealQuantity = 0
        }
      }
    },
    async isShowEditWorkItemDialogBtn (item) {
      this.editedWorkItemIndex = this.editedEngineerWork.EngineerWorkItems.indexOf(item)
      this.editedWorkItem = JSON.parse(JSON.stringify(item))
      if (!this.editedWorkItem.ReturnItem.IsCustomerDevice) {
        this.editedWorkItem.ReturnItem.Custody = 1
      }
      if (this.editedWorkItem.ReturnItem.HasSerialNumber) {
        await this.getReturnItemSerialNumber()
      }

      if (
        this.editedWorkItem.ReturnItem.HasSerialNumber &&
        !this.editedWorkItem.ReturnItem.SerialNumber
      ) {
        this.editedWorkItem.ReturnItem.SerialNumber = {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        }
      }

      this.editedWorkItem.ReturnItem = JSON.parse(JSON.stringify(this.editedWorkItem.ReturnItem))
      this.editedWorkItem = JSON.parse(JSON.stringify(this.editedWorkItem))
      await this.getAuthorizeMappingByItemIdAndItemSerialNumber()
      if (this.authorizeMappingObj) {
        this.tempGmServerType = this.authorizeMappingObj.GmServerType
      }
      this.isShowEditWorkItemDialog = true
    },
    async addWorkItem () {
      const isValid = await this.$refs.workItem.validate()
      if (isValid) {
        if (this.editedWorkItemIndex > -1) {
          this.editedEngineerWork.EngineerWorkItems.splice(
            this.editedWorkItemIndex,
            1,
            this.editedWorkItem
          )
        } else {
          this.editedEngineerWork.EngineerWorkItems.push(this.editedWorkItem)
        }
        this.closeEditWorkItem()
      }
    },
    closeEditWorkItem () {
      this.isShowEditWorkItemDialog = false
      this.$nextTick(() => {
        this.editedWorkItem = JSON.parse(JSON.stringify(this.defaultWorkItem))
        this.editedWorkItemIndex = -1
        this.defaultText = ''
      })
    },
    isShowDeleteWorkItemDialogBtn (item) {
      this.editedWorkItemIndex = this.editedEngineerWork.EngineerWorkItems.indexOf(item)
      this.editedWorkItem = JSON.parse(JSON.stringify(item))
      this.isShowDeleteEngineerWorkDialog = true
    },
    async confirmDeleteWorkItem () {
      this.editedEngineerWork.EngineerWorkItems.splice(this.editedWorkItemIndex, 1)
      this.closeDeleteWorkItem()
    },
    closeDeleteWorkItem () {
      this.isShowDeleteEngineerWorkDialog = false
      this.$nextTick(() => {
        this.editedWorkItem = JSON.parse(JSON.stringify(this.defaultWorkItem))
        this.editedWorkItemIndex = -1
      })
    },
    async getTotalCount () {
      let param = {
        returnItemId: this.editedWorkItem.ReturnItem.ItemId,
        number: this.tempWatchNumber,
        groupNumber: this.editedWorkItem.ReturnItem.Type,
        customerDeviceType: this.editedWorkItem.ReturnItem.CustomerDeviceType
          ? this.editedWorkItem.ReturnItem.CustomerDeviceType
          : null,
        customerId: this.editedEngineerWork.CustomerId
      }
      let response = await HttpSerialNumber.GetSerialNumberListForEgCount(param)
      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getReturnItemSerialNumber () {
      if (this.searchCount > (this.page - 1) * this.perPage && this.searchCount !== 0) {
        this.isLoadingItem = true
        let param = {
          ReturnItemId: this.editedWorkItem.ReturnItem.ItemId,
          GroupNumber: this.editedWorkItem.ReturnItem.Type,
          SearchNumber: this.tempWatchNumber,
          Page: this.page,
          PerPage: this.perPage,
          CustomerDeviceType: this.editedWorkItem.ReturnItem.CustomerDeviceType
            ? this.editedWorkItem.ReturnItem.CustomerDeviceType
            : null,
          CustomerId: this.editedEngineerWork.CustomerId
        }
        let response = await HttpSerialNumber.GetSerialNumberList(param)
        if (response.status === 200) {
          this.returnItemSerialNumberList = [
            ...this.returnItemSerialNumberList,
            ...response.data.Data
          ]
        } else {
          this.returnItemSerialNumberList = []
        }
      }
    }
  }
}
</script>
